export default {
  carrierCaption: {
    id: 'product_jp_item_reassurance_carrier_caption',
    defaultMessage: 'works with all carrier*',
  },
  carrier: {
    id: 'product_jp_item_reassurance_carrier',
    defaultMessage: 'SIM Unlocked',
  },
}
